export const InternSatisfactionEnFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [
    {
      w: '100%', h: 70, text: 'National Taiwan University of Science and Technology\nStudent Off-campus Internship Questionnaire',
      border_width: 0, font_size: 19, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    {
      w: '100%', h: 210, padding: 10, align: 'left', font_family: '標楷體', font_size: 14,
      text: 'To whom it may concern:\n\nThank you for offering internships to Taiwan Tech students! Your support allows tremendous growth opportunities for students. Taiwan Tech uses this questionnaire to evaluate student performance and your level of satisfaction with the intern during their internship. The data collected is aggregated by the school for future reference and planning. All the answers you provide are analyzed in a bulk analysis. Any personal data you provide will not be published or used for any other purpose. Please feel free to answer the questions honestly. Thank you for your cooperation and assistance.\n\nSincerely,\nNational Taiwan University of Science and Technology',
    },

    {
      w: '100%', h: 30, text: 'Information',
      border_width: 0, align: 'left',
    },

    { w: '18%', h: 30, text: 'Business Name' },
    { w: '32%', h: 30, text: form_data.enterprise_name },
    { w: '18%', h: 30, text: 'Date' },
    { w: '32#', h: 30, text: date_to_str_yyyy_mm_dd(form_data.filling_date) },

    { w: '18%', h: 30, text: 'Evaluator Name' },
    { w: '32%', h: 30, text: form_data.company_scorer },
    { w: '18%', h: 30, text: 'Occupation' },
    { w: '32%', h: 30, text: form_data.company_role },

    { w: '18%', h: 30, text: 'Intern Name' },
    { w: '32%', h: 30, text: form_data.student_name },
    { w: '18%', h: 30, text: 'Department' },
    { w: '32%', h: 30, text: form_data.department_id },

    { w: '28%', h: 30, text: 'Internship Job Description' },
    { w: '72%', h: 30, text: form_data.intern_content },
    
    { w: '18%', h: 30, text: 'Internship Period' },
    { w: '82%', h: 30, text: `${date_to_str(form_data.start_time)}～${date_to_str(form_data.end_time)}` },

    {
      w: '100%', h: 30, text: 'Satisfaction survey',
      border_width: 0, align: 'left',
    },

    { w: '100%', h: 30, padding: 10, align: 'right', text: '(Very Satisfied: 5, Satisfied: 4, Neutral: 3, Dissatisfied: 2, Very Dissatisfied: 1 )' },

    ...check_radio_table_key_check(blueprint.find(block => block.key == 'check').items, form_data.check),

    { next_page: true },
    {
      w: '100%', h: 30, text: 'Other comments',
      border_width: 0, align: 'left',
    },
    { w: '100%', h: 100, padding: 10, align: 'left', baseline: 'top', text: form_data.opinion_share },
  ];
}

function check_radio_table_key_check(items, values) {
  return items.map((item, index) => {
    let h = (index == 15 ? 50 : 30);
    return [
      { w: '70%', h, padding: 10, align: 'left', text: item },
      { w: '30%', h, padding: 10, texts: values[index] },
    ];
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}